/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  
  Modified by yang@onerockwell
  
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

let debounce = Date.now();

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
    console.log('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
    console.log('Update note ' + JSON.stringify(note));
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function () {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function (cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function (XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function (data, callback, errorCallback) {
    console.log('Call to add multiple: ' + JSON.stringify(data));
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function (jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function (line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function (XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
    console.log('[shopify add item from form with 2]');
    console.log(JSON.stringify(jQuery(form).serialize()))
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function (jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function (line_item) {
                console.log('Success of ' + JSON.stringify(line_item))
                if ((typeof callback) === 'function') {
                    console.log('with a type of function')
                    callback(line_item, form);
                } else {
                    console.log('without a type of function')
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function (XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
    console.log('Get cart')
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
    console.log('Call to change item ' + JSON.stringify(line) + ' to ' + JSON.stringify(quantity));
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function () {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function (cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function (XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};



/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function (variant, selector) {
    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    // Selectors
    if (selector.domIdPrefix.split('-').length > 1) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('#AddToCart-' + selectorArray[1]);
    } else {
        var $addToCart = $('#AddToCart');
    }

    var $productWrapper = $addToCart.parents('.product-core'), // Defined the Product Dom Scope
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $addToCartText = $productWrapper.find('.add-to-cart-text');

    // Variant
    if (variant) {
        // Select a valid variant if available
        if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled').prop('disabled', false);
            if ($addToCart.hasClass('pre-order')) {
                $addToCartText.html("");
            } else {
                $addToCartText.html("Add to cart");
            }
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass('disabled').prop('disabled', true);
            if (!$addToCart.hasClass('inquire')) {
                $addToCartText.html("Sold Out");
            }
        }
        // console.log('variant selected and update price');
        // console.log(selector);
        // Regardless of stock, update the product price
        $productPrice.html(theme.Currency.formatMoney(variant.price, moneyFormat));

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(theme.Currency.formatMoney(variant.compare_at_price, moneyFormat)).show();
        } else {
            $comparePrice.hide();
        }

    } else {
        $addToCart.addClass('disabled').prop('disabled', true);
        if (!$addToCart.hasClass('inquire')) {
            $addToCartText.html("Sold Out");
        }
    }
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function (options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function () {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function (cart) {
        if ($cartCountSelector) {
            // Subtract slider bundle children from the visible count
            var visibleCount = cart.item_count;
            (cart.items || []).forEach(function (item) {
                if (item.properties && (item.properties._slider_bundle_child === 'true' || item.properties._charm_bundle_child === 'true')) {
                    visibleCount -= item.quantity;
                }
            });
            $cartCountSelector.html(visibleCount).removeClass('hidden-count');

            if (visibleCount === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat));
        }
    };

    formOverride = function () {
        /* $formContainer.on('submit', function (evt) {
             evt.preventDefault();
             var proceed = true;
             var $currForm = $(evt.target);
             var $selects = $currForm.find('select');
             $.each($selects, function (i, v) {
                 if ($(v).val() == '') {
                     proceed = false;
                     return false;
                 }
             });
 
             if (!proceed) {
                 alert('Please select all options');
                 return false;
             }
 
             $addToCart.prop('disabled', true);
 
             // Add class to be styled if desired
             $addToCart.removeClass('is-added').addClass('is-adding');
 
             // Remove any previous quantity errors
             $('.qty-error').remove();
 
             console.log('Add item from form')
             console.log(evt.target);
 
             ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
         });*/
    };

    itemAddedCallback = function (product) {
        $addToCart.prop('disabled', false);
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(function (cart) {
            console.log('getCart callback 2 on', $body[0]);
            cartUpdateCallback(cart);
            $body.trigger('afterAddToCart.ajaxCart', cart);
        });
    };

    itemErrorCallback = function (res, text) {
        $addToCart.removeClass('is-adding is-added');
        $addToCart.prop('disabled', false);

        if (!!text) {
            if (res.status == 422) {
                $formContainer.after('<div class="errors qty-error">' + text + '</div>')
            }
        }
    };

    cartUpdateCallback = function (cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);

    };

    buildCart = function (cart) {
        console.log('Building cart')
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p class="ajaxcart__empty">' + "Your cart is currently empty." + '</p>');
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            animation_row = 1,
            source = $("#AJAXCartTemplate").html(),
            template = Handlebars.compile(source);

        console.log(cart.items);

        var totalOriginalPrice = 0;

        // Pre-pass: compute slider bundle totals so children can be hidden
        var sliderBundles = {};
        console.log('[SliderBundle] Pre-pass starting, items:', cart.items.length);
        $.each(cart.items, function (index, cartItem) {
            var props = cartItem.properties || {};
            var bid = props._slider_bundle_id || props._charm_bundle_id;
            console.log('[SliderBundle] Item', index, ':', cartItem.product_title, 'bid:', bid, 'parent:', props._slider_bundle_parent || props._charm_bundle_parent, 'child:', props._slider_bundle_child || props._charm_bundle_child);
            if (!bid) return;
            if (!sliderBundles[bid]) sliderBundles[bid] = { childPriceTotal: 0, childKeys: [] };
            if (props._slider_bundle_child === 'true' || props._charm_bundle_child === 'true') {
                sliderBundles[bid].childPriceTotal += cartItem.price * cartItem.quantity;
                sliderBundles[bid].childKeys.push(cartItem.key);
            }
        });
        console.log('[SliderBundle] Bundles found:', JSON.stringify(sliderBundles));

        // Add each item to our handlebars.js data
        $.each(cart.items, function (index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            // Skip slider bundle children — they're visually merged into the parent
            var props = cartItem.properties || {};
            if (props._slider_bundle_child === 'true' || props._charm_bundle_child === 'true') {
                console.log('[SliderBundle] SKIPPING child item:', cartItem.product_title);
                return true; // continue
            }
            console.log('[SliderBundle] RENDERING item:', cartItem.product_title, 'isParent:', props._slider_bundle_parent || props._charm_bundle_parent, 'hasPhoto:', !!props.photo, 'props:', JSON.stringify(cartItem.properties));

            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            // Create item's data object and add to 'items' array

            animation_row += 2;

            // For slider bundle parents, combine the child prices into the display price
            var displayLinePrice = cartItem.line_price;
            var displayOriginalLinePrice = cartItem.original_line_price;
            var parentBid = props._slider_bundle_id || props._charm_bundle_id;
            if ((props._slider_bundle_parent === 'true' || props._charm_bundle_parent === 'true') && parentBid && sliderBundles[parentBid]) {
                var childTotal = sliderBundles[parentBid].childPriceTotal;
                displayLinePrice += childTotal;
                displayOriginalLinePrice += childTotal;
            }

            // For merged bundle items, convert _Charm properties to visible Charm properties
            var displayProps = {};
            if (cartItem.properties) {
                for (var key in cartItem.properties) {
                    if (key.indexOf('_Charm ') === 0) {
                        displayProps[key.substring(1)] = cartItem.properties[key];
                    } else {
                        displayProps[key] = cartItem.properties[key];
                    }
                }
            }

            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                animationRow: animation_row,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: displayProps,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: theme.Currency.formatMoney(cartItem.price, theme.settings.moneyFormat),
                vendor: cartItem.vendor,
                linePrice: theme.Currency.formatMoney(displayLinePrice, theme.settings.moneyFormat),
                originalLinePrice: theme.Currency.formatMoney(displayOriginalLinePrice, theme.settings.moneyFormat),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
                isGiftCard: cartItem.gift_card
            };

            if (!isNaN(parseFloat(displayOriginalLinePrice))) {
                totalOriginalPrice += parseFloat(displayOriginalLinePrice);
            }

            items.push(item);
        });

        // Gather all cart data and add to DOM

        animation_row += 2;

        data = {
            items: items,
            note: cart.note,
            lastAnimationRow: animation_row,
            totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
            totalCartDiscount: false, //cart.total_discount === 0 || (cart?.items || []).some(item => (item?.discounts || []).some(discount => discount.title === "Discount"))? 0 : "I18n Error: Missing interpolation value \"savings\" for \"You're saving {{ savings }}\"".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
            totalOriginalPrice: theme.Currency.formatMoney(totalOriginalPrice, theme.settings.moneyFormat)
        };

        $cartContainer.append(template(data));

        // Force-update cart bubble count to exclude hidden bundle children
        // Runs at 250ms and 750ms to beat the refreshBubble() in theme.liquid (500ms)
        var visibleItemCount = items.length;
        function fixBubbleCount() {
            var bubbles = document.querySelectorAll('.cart-link__bubble');
            for (var b = 0; b < bubbles.length; b++) {
                bubbles[b].textContent = visibleItemCount;
                if (visibleItemCount > 0) {
                    bubbles[b].classList.add('cart-link__bubble--visible');
                } else {
                    bubbles[b].classList.remove('cart-link__bubble--visible');
                }
            }
        }
        setTimeout(fixBubbleCount, 250);
        setTimeout(fixBubbleCount, 750);

        cartCallback(cart);

        // Dynamic Free Shipping Message
        var $freeSuccess = $cartContainer.find('.free-success');
        var $freeRemaining = $cartContainer.find('.free-remaining');
        var free_threshold = '45';
        var free_threshold_price = parseFloat(free_threshold) * 100;

        if (totalOriginalPrice >= free_threshold_price) {
            $freeSuccess.show();
            $freeRemaining.hide();
        } else {
            var remaining = free_threshold_price - totalOriginalPrice;
            $freeSuccess.hide();
            $freeRemaining.find('span').html(theme.Currency.formatMoney(remaining, theme.settings.moneyFormat));
            $freeRemaining.find('.ajaxcart__countdown__inner').width(`${totalOriginalPrice / free_threshold}%`);
            $freeRemaining.show();
        }

    };

    cartCallback = function (cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    // Clear checkout button loading state when returning via back button (bfcache)
    window.addEventListener('pageshow', function (evt) {
        if (evt.persisted) {
            $('.cart__checkout').removeClass('btn--loading');
        }
    });

    adjustCart = function () {
        console.log('Adjusting cart');
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function () {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $body.on('click', '.ajaxcart__qty-remove', function (e) {
            e.preventDefault();
            var $el = $(this),
                line = $el.data('line');

            if (isUpdating) {
                return;
            }
            updateQuantity(line, 0);
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function () {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function (evt) {
            console.log('prevent default on submit');
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function () {
            var $el = $(this);
            setTimeout(function () {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // If removing a slider/charm bundle parent, also remove its children
            if (qty === 0) {
                $.getJSON('/cart.js', function (cart) {
                    var parentItem = cart.items[line - 1];
                    var pProps = parentItem && parentItem.properties || {};
                    if (pProps._slider_bundle_parent === 'true' || pProps._charm_bundle_parent === 'true') {
                        var bid = pProps._slider_bundle_id || pProps._charm_bundle_id;
                        var updates = {};
                        cart.items.forEach(function (item) {
                            var iBid = item.properties && (item.properties._slider_bundle_id || item.properties._charm_bundle_id);
                            if (iBid === bid) {
                                updates[item.key] = 0;
                            }
                        });
                        setTimeout(function () {
                            $.ajax({
                                type: 'POST', url: '/cart/update.js',
                                data: JSON.stringify({ updates: updates }),
                                contentType: 'application/json',
                                dataType: 'json',
                                success: function (cart) { adjustCartCallback(cart); },
                                error: function () { ShopifyAPI.changeItem(line, qty, adjustCartCallback); }
                            });
                        }, 250);
                        return;
                    }
                    setTimeout(function () {
                        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
                    }, 250);
                });
                return;
            }

            // If changing a bundle parent qty, also sync children
            $.getJSON('/cart.js', function (cart) {
                var parentItem = cart.items[line - 1];
                var pProps = parentItem && parentItem.properties || {};
                if (pProps._slider_bundle_parent === 'true' || pProps._charm_bundle_parent === 'true') {
                    var bid = pProps._slider_bundle_id || pProps._charm_bundle_id;
                    var updates = {};
                    cart.items.forEach(function (item) {
                        var iBid = item.properties && (item.properties._slider_bundle_id || item.properties._charm_bundle_id);
                        if (iBid === bid) {
                            updates[item.key] = qty;
                        }
                    });
                    setTimeout(function () {
                        $.ajax({
                            type: 'POST', url: '/cart/update.js',
                            data: JSON.stringify({ updates: updates }),
                            contentType: 'application/json',
                            dataType: 'json',
                            success: function (cart) { adjustCartCallback(cart); },
                            error: function () { ShopifyAPI.changeItem(line, qty, adjustCartCallback); }
                        });
                    }, 250);
                    return;
                }
                setTimeout(function () {
                    ShopifyAPI.changeItem(line, qty, adjustCartCallback);
                }, 250);
            });
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function () {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function (cart) { });
        });
    };

    adjustCartCallback = function (cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function () {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function () {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function () {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function () {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');

        if (numInputs.length) {
            numInputs.each(function () {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function () {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function (qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
            console.log('[adjusted quantity to 1]');
        }
        console.log('qty ' + qty);
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));